var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:['card',`bg-${_vm.color}`],attrs:{"to":_vm.item.link}},[_c('div',{staticClass:"card__img"},[_c('img',{attrs:{"src":_vm.item.image,"alt":_vm.item.title}})]),_c('div',{staticClass:"card__content"},[_c('h3',[_vm._v(_vm._s(_vm.item.title))]),_c('p',[_vm._v(_vm._s(_vm.item.info))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }